module.exports = {
      id: "hamburger-facebook-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#hamburger-facebook",
      toString: function () {
        return this.url;
      }
    }